import api from '../api';
import axios from 'axios';

const url = (path) => process.env.REACT_APP_BACKEND_URL + path;

export default {
    // Boards + lists the logged-in user may share tickets to
    TARGETS: () => axios.get(url(api.taskShare.TARGETS())),
    // Boards/lists a ticket is shared to
    GET: (taskId) => axios.get(url(api.taskShare.GET(taskId))),
    SHARE: (taskId, data) => axios.post(url(api.taskShare.SHARE(taskId)), data),
    UNSHARE: (shareId) => axios.delete(url(api.taskShare.UNSHARE(shareId))),
    // Move a shared ticket on the board it was shared to (only the share moves)
    MOVE: (taskId, boardListId) => axios.put(url(api.taskShare.MOVE(taskId)), { boardListId }),
    // Per-user "may share tickets to" setting (admins)
    GET_SETTING: (userId) => axios.get(url(api.taskShare.SETTING(userId))),
    SET_SETTING: (userId, targets) => axios.put(url(api.taskShare.SETTING(userId)), { targets }),
};
